//!#system	

<template>
	<div>
		<v-layout>
			<v-dialog v-model="isLoadingLong" persistent width="300">
				<v-card color="primary" dark>
					<v-card-text>
						{{loadingPhrase}}
						<v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
					</v-card-text>
				</v-card>
			</v-dialog>
		</v-layout>
		<v-card v-if="isLoading" flat>
			<v-progress-linear :indeterminate="true"></v-progress-linear>
		</v-card>
		<v-card v-if="isNotFound" color="transparent" elevation="0" dark>
			<v-card-text style="text-align: center;margin-top: 100px;">
				<div style="font-size: 60px; margin-bottom: 20px;">
					Enrollment not found...
				</div>
				<v-icon x-large style="font-size: 160px;opacity: 0.8;">mdi-file-sign</v-icon>
				<div v-if="isPinned">
					<pin-button :routeInfo="routeInfo" />
				</div>
			</v-card-text>
		</v-card>
		<v-card v-if="isLoaded" flat>
			<v-toolbar 
				flat 
				dense
				:color="'teal darken-2'"
				dark
			>
				<v-slide-y-transition>
					<v-toolbar-title v-show="animateTitle">
						<v-icon class="iconWidth">mdi-file-sign</v-icon>
						<span class="titleOpacity">&nbsp;&nbsp;&nbsp; Enrollment: </span>
							<span class="heroTitle">{{detail.enrollmentNumber}}</span>
					</v-toolbar-title>
				</v-slide-y-transition>
				<v-spacer></v-spacer>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" icon @click="openCreateWindow()">
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</template>
					<span>Create</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" icon @click="openCreateWindow();getCopyJson=true;">
							<v-icon>mdi-content-copy</v-icon>
						</v-btn>
					</template>
					<span>Create New Like This</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" icon @click="openUpdateWindow()">
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span>Edit</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-btn v-on="on" icon @click="refresh">
							<v-icon>mdi-sync</v-icon>
						</v-btn>
					</template>
					<span>Refresh</span>
				</v-tooltip>
				<pin-button :routeInfo="routeInfo" />
			</v-toolbar>

			<v-container fluid>
				<v-layout wrap>
					<v-flex xs8>
						<v-progress-circular
							v-if="!Array.isArray(possibleActions)"
							indeterminate
							color="primary"
						></v-progress-circular>
						<div v-if="Array.isArray(possibleActions)">
							<span v-for="action in possibleActions" :key="action.name">
								<v-slide-x-transition v-if="action.isRuleButton">
									<v-btn 
										class="ma-1"
										depressed small
										:disabled="!action.isExecutable"
										@click="runRule(action)"
										:loading="action.isLoading"
										v-show="showRuleButtons"
									>
										{{action.friendlyName}}
									</v-btn>
								</v-slide-x-transition>
								<v-btn
									v-else-if="action.ui && action.ui.actionParams === true"
									class="ma-1"
									depressed small
									:disabled="!action.isExecutable"
									:loading="action.isLoading"
									@click="currentAction = action; modals.modalActionParams = true;"
								>
									{{action.friendlyName}}
								</v-btn>
								<v-btn
									v-else-if="action.buttonUnavailable !== true"
									class="ma-1"
									depressed small
									:disabled="!action.isExecutable"
									:loading="action.isLoading"
									@click="currentAction = action; runMethod('initiate_' + action.methodName, action)"
								>
									{{action.friendlyName}}
									<v-icon v-if="action.externalLink" right x-small>mdi-open-in-new</v-icon>
								</v-btn>
							</span>
							<v-menu offset-y v-if="showMoreMenu">
								<template v-slot:activator="{ on }">
									<v-btn
										class="ma-1"
										depressed small
										v-on="on"
									>
										More
										<v-icon right x-small>mdi-chevron-down</v-icon>
									</v-btn>
								</template>
								<v-list dense>
									<template v-for="action in moreActions">
										<v-list-item v-if="action.isRuleButton" @click="runRule(action)" :disabled="!action.isExecutable" :key="action.name">
											<v-list-item-title>{{action.friendlyName}}</v-list-item-title>
										</v-list-item>
										<v-list-item v-else-if="action.ui && action.ui.actionParams === true" @click="currentAction = action; modals.modalActionParams = true;" :disabled="!action.isExecutable" :key="action.name">
											<v-list-item-title>{{action.friendlyName}}</v-list-item-title>
										</v-list-item>
										<v-list-item v-else-if="action.buttonUnavailable !== true" @click="currentAction = action; runMethod('initiate_' + action.methodName, action)" :disabled="!action.isExecutable" :key="action.name">
											<v-list-item-title>{{action.friendlyName}}</v-list-item-title>
										</v-list-item>
									</template>
								</v-list>
							</v-menu>
							<lock-status v-if="detail.locks.updateLock || detail.locks.actionLock" :updateLock="detail.locks.updateLock" :actionLock="detail.locks.actionLock" />
						</div>
						
					</v-flex>
					<v-flex xs4>
						<div class="caption" style="font-family: 'Poppins' !important;">
							<v-spacer></v-spacer>
							Created <data-string :value="detail.createdAt" :cannotBeInFuture="true" />
							<div v-if="detail.createdAt != detail.updatedAt">
								Updated <data-string :value="detail.updatedAt" :cannotBeInFuture="true" />
							</div>
						</div>
					</v-flex>
				</v-layout>
			</v-container>
			<v-divider></v-divider>

			<v-container fluid>
				<v-layout wrap>
					<v-flex xs12>  
						<tags :tagged="detail.tags" :namespace="routeInfo.namespace" :title="routeInfo.title" :name="routeInfo.name" :pluralName="routeInfo.pluralName" :id="detail.id" :key="Array.isArray(detail.tags) ? detail.tags.join(',') : ''" @update="reloadTimeline" />
					</v-flex>	
				</v-layout>
			</v-container>

			<v-container fluid>
				<v-layout wrap>
					<!-- left column -->
					<v-flex xs12 md12 lg8 xl9>

						<queues-current :routeInfo="routeInfo" :queues="detail.queues" :isLoading="isLoading" @updated="refresh" />

						<enrollment-detail @updated="refresh" :routeInfo="routeInfo" v-model="detail" :isBase="true" :headerColor="'teal darken-2'" />

					</v-flex>

					<!-- right column -->
					<v-flex xs12 md12 lg4 xl3>
						<links-current ref="links" :routeInfo="routeInfo" />
						<timeline v-bind:routeInfo="routeInfo" ref="timeline" />
					</v-flex>

				</v-layout>
			</v-container>

			
		</v-card>
		<v-dialog persistent scrollable max-width="600px" v-model="createWindow" :key="createWindowKey">
			<create :instanceId="getCopyJson ? detail.id : ''" @close="closeCreateWindow" />
		</v-dialog>
		<v-dialog v-model="updateWindow" persistent max-width="600px" :key="updateWindowKey" scrollable>
			<update @close="closeUpdateWindow" :currentData="detail" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalAvailableTags" persistent max-width="600px" :key="modals.modalAvailableTagsKey" scrollable>
			<available-tags :routeInfo="routeInfo" :detail="detail" :action="currentAction" @close="closeAvailableTags" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalAddToQueue" persistent max-width="600px" :key="modals.modalAddToQueueKey" scrollable>
			<add-to-queue :routeInfo="routeInfo" :detail="detail" :action="currentAction" @close="closeAddToQueue" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalRemoveFromQueue" persistent max-width="600px" :key="modals.modalRemoveFromQueueKey" scrollable>
			<remove-from-queue :routeInfo="routeInfo" :detail="detail" :action="currentAction" @close="closeRemoveFromQueue" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalAddTags" persistent max-width="600px" :key="modals.modalAddTagsKey" scrollable>
			<add-tags :routeInfo="routeInfo" :detail="detail" :action="currentAction" @close="closeAddTags" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalRemoveTags" persistent max-width="600px" :key="modals.modalRemoveTagsKey" scrollable>
			<remove-tags :routeInfo="routeInfo" :detail="detail" :action="currentAction" @close="closeRemoveTags" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalLock" persistent max-width="300px" :key="modals.modalLockKey" scrollable>
			<lock :routeInfo="routeInfo" :detail="detail" :action="currentAction" @close="closeLock" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalDelete" persistent max-width="600px" :key="modals.modalDeleteKey" scrollable>
			<delete :routeInfo="routeInfo" :detail="detail" :action="currentAction" @close="closeDelete" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalLinkModal" persistent max-width="600px" :key="modals.modalLinkModalKey" scrollable>
			<link-modal :routeInfo="routeInfo" :detail="detail" :action="currentAction" @close="closeLinkModal" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.modalActionParams" :key="modals.modalActionParamsKey" persistent max-width="600px" scrollable>
			<modal-action :routeInfo="routeInfo" :detail="detail" :action="currentAction" @close="closeActionModals" @refresh="refresh" />
		</v-dialog>
		<v-dialog v-model="modals.ruleConfirm" :key="modals.ruleConfirmKey" persistent max-width="600px">
			<v-card v-if="currentRuleButtonLoading">
				<div style="padding: 40px;" class="text-center">
					<v-progress-circular
						:size="70"
						:width="7"
						indeterminate
						color="blue-grey lighten-3"
					></v-progress-circular>
				</div>
			</v-card>
			<v-card v-else>
				<v-card-title class="headline grey lighten-2" primary-title>
					<div ref="filter-title-element">Are you sure?</div>
				</v-card-title>
				<v-card-text class="py-6">
					Are you sure you want to run the action "{{currentRuleButton.friendlyName}}"?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="closeRuleConfirm">Exit</v-btn>
					<v-btn color="primary" :loading="currentRuleButtonLoading" text @click="runRule(currentRuleButton, true)">
						Run
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import tools from '@/tools';
import series from 'to-series';
import apiService from '@/apiService';
import DataString from '@/components/pieces/DataString';
import Timeline from './EnrollmentTimeline';
import Create from './EnrollmentCreate';
import Update from './EnrollmentUpdate';
import Tags from './EnrollmentTags';
import QueuesCurrent from '@/components/pieces/QueuesCurrent';
import LinksCurrent from '@/components/pieces/LinksCurrent';
import PinButton from '@/components/pieces/PinButton';
import DisplayContainer from '@/components/display/DisplayContainer';
import LockStatus from '@/components/pieces/LockStatus';
import ModalAction from '@/views/modals/ModalAction';
import EnrollmentDetail from '@/views/custom/people/Enrollment/EnrollmentDetail.vue';

import AvailableTags from '@/views/modals/AvailableTags';
import AddToQueue from '@/views/modals/AddToQueue';
import RemoveFromQueue from '@/views/modals/RemoveFromQueue';
import AddTags from '@/views/modals/AddTags';
import RemoveTags from '@/views/modals/RemoveTags';
import Lock from '@/views/modals/Lock';
import Delete from '@/views/modals/Delete';
import LinkModal from '@/views/modals/LinkModal';

export default {
	components: {
		DataString,
		Timeline,
		Tags,
		QueuesCurrent,
		LinksCurrent,
		DisplayContainer,
		LockStatus,
		ModalAction,
		PinButton,
		// eslint-disable-next-line
		AvailableTags,
		AddToQueue,
		RemoveFromQueue,
		AddTags,
		RemoveTags,
		Lock,
		Delete,
		LinkModal,
		EnrollmentDetail,
		
		Create,
		Update
	},
	data() {
		return {
			animateTitle: false,
			cached: false,
			objectName: '',
			isLoading: false,
			isLoadingLong: false,
			isNotFound: false,
			loadingTime: 0,
			errorState: false,
			showRuleButtons: false,
			routeInfo: {
				namespace: 'people', 
				title: 'Enrollment', 
				name: 'enrollment', 
				pluralName: 'enrollments',
				context: '',
				groupedWith: '',
				basePath: '',
				id: null
			},
			createForceActionModal: '',
			detail: {},
			parent: {
				namespace: '', 
				title: '', 
				name: '', 
				pluralName: '',
				context: '',
				groupedWith: '',
				basePath: '',
				id: null
			},
			children: {
				client: {
					name: 'Client',
					fields: {"firstName":{"name":"firstName","fieldName":"firstName","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":1,"max":400,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The client first name.","icon":"","listInclude":false,"sortable":true,"displayName":"First Name","displayFullWidth":false},"lastName":{"name":"lastName","fieldName":"lastName","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":1,"max":400,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The client last name.","icon":"","listInclude":false,"sortable":true,"displayName":"Last Name","displayFullWidth":false},"emailAddress":{"name":"emailAddress","fieldName":"emailAddress","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":5,"max":100,"nonNull":false,"autoTrim":true,"header":true,"type":"emailAddress","displayFullWidth":false},"index":true,"unique":true,"direction":"ASC","updatable":true,"createable":true,"description":"The unique email address for this client.","icon":"","listInclude":false,"sortable":true,"displayName":"Email Address","displayFullWidth":false},"phoneNumber":{"name":"phoneNumber","fieldName":"phoneNumber","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":0,"max":50,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The client's phone number.","icon":"","listInclude":false,"sortable":true,"displayName":"Phone Number","displayFullWidth":false},"numberOfAdults":{"name":"numberOfAdults","fieldName":"numberOfAdults","relationship":null,"isForeignKey":false,"default":0,"defaultIsRandom":false,"type":{"primitive":"number","min":0,"max":50,"nonNull":true,"persistenceDefault":0,"header":true,"type":"integer"},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"Number of adults in the household.","icon":"","listInclude":false,"sortable":true,"displayName":"Number Of Adults","displayFullWidth":false},"language":{"name":"language","fieldName":"language","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":0,"max":150,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The language spoken at home.","icon":"","listInclude":false,"sortable":true,"displayName":"Language","displayFullWidth":false},"streetAddress":{"name":"streetAddress","fieldName":"streetAddress","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":3,"max":150,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The address-1 / street address (number + street name).","icon":"","listInclude":false,"sortable":true,"displayName":"Street Address","displayFullWidth":false},"unitNumber":{"name":"unitNumber","fieldName":"unitNumber","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":0,"max":25,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The suite/apt information on the address.","icon":"","listInclude":false,"sortable":true,"displayName":"Unit Number","displayFullWidth":false},"city":{"name":"city","fieldName":"city","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":3,"max":25,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The city/locale name.","icon":"","listInclude":false,"sortable":true,"displayName":"City","displayFullWidth":false},"state":{"name":"state","fieldName":"state","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":2,"max":25,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The state/province name.","icon":"","listInclude":false,"sortable":true,"displayName":"State","displayFullWidth":false},"zip":{"name":"zip","fieldName":"zip","relationship":null,"isForeignKey":false,"default":"","defaultIsRandom":false,"type":{"primitive":"string","min":5,"max":15,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The zip/postal code.","icon":"","listInclude":false,"sortable":true,"displayName":"Zip","displayFullWidth":false},"country":{"name":"country","fieldName":"country","relationship":null,"isForeignKey":false,"default":"US","defaultIsRandom":false,"type":{"primitive":"string","min":2,"max":100,"nonNull":false,"autoTrim":true,"autoTruncate":false,"header":true,"type":"character","displayFullWidth":false,"meta":{},"syskey":false},"index":false,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The country code.","icon":"","listInclude":false,"sortable":true,"displayName":"Country","displayFullWidth":false},"lastCheckin":{"name":"lastCheckin","fieldName":"lastCheckin","relationship":null,"isForeignKey":false,"default":null,"defaultIsRandom":false,"type":{"primitive":"date","min":null,"max":null,"nonNull":false,"persistenceDefault":"NOW()","header":true,"type":"timestamp"},"index":true,"unique":false,"direction":"ASC","updatable":true,"createable":true,"description":"The last time that the client checked in at a distribution.","icon":"","listInclude":false,"sortable":true,"displayName":"Last Checkin","displayFullWidth":false}},
					childDisplayType: 'table'
				}
			},
			depth: {
			},
			actionModals: [{"action":"setTags","ui":{"initialModal":{"componentName":"AvailableTags","componentPath":"@/views/modals/AvailableTags","componentElementName":"available-tags","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"addToQueue","ui":{"initialModal":{"componentName":"AddToQueue","componentPath":"@/views/modals/AddToQueue","componentElementName":"add-to-queue","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"removeFromQueue","ui":{"initialModal":{"componentName":"RemoveFromQueue","componentPath":"@/views/modals/RemoveFromQueue","componentElementName":"remove-from-queue","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"addTags","ui":{"initialModal":{"componentName":"AddTags","componentPath":"@/views/modals/AddTags","componentElementName":"add-tags","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"removeTags","ui":{"initialModal":{"componentName":"RemoveTags","componentPath":"@/views/modals/RemoveTags","componentElementName":"remove-tags","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"lock","ui":{"initialModal":{"componentName":"Lock","componentPath":"@/views/modals/Lock","maxWidth":"300px","componentElementName":"lock"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"archive","ui":{"initialModal":{"componentName":"Delete","componentPath":"@/views/modals/Delete","componentElementName":"delete","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}},{"action":"link","ui":{"initialModal":{"componentName":"LinkModal","componentPath":"@/views/modals/LinkModal","componentElementName":"link-modal","maxWidth":"600px"},"actionParams":false,"justRunActionAndRefresh":false}}],
			fields: [],
			rootFields: [],
			comment: '',
			editWindow: false,
			createWindow: false,
			updateWindow: false,
			archiveWindow: false,
			getCopyJson: false,
			rotatingKey: tools.randomString(10),
			possibleActions: [],
			moreActions: [],
			lastLifecyle: '',
			isLoaded: false,
			currentRuleButton: {},
			currentRuleButtonLoading: false,
			currentAction: {},
			modals: {
				ruleConfirm: false,
				ruleConfirmKey: tools.randomString(10),
				modalActionParams: false,
				modalActionParamsKey: tools.randomString(10),
				modalAvailableTags: false,
				modalAvailableTagsKey: tools.randomString(10),
								modalAddToQueue: false,
				modalAddToQueueKey: tools.randomString(10),
								modalRemoveFromQueue: false,
				modalRemoveFromQueueKey: tools.randomString(10),
								modalAddTags: false,
				modalAddTagsKey: tools.randomString(10),
								modalRemoveTags: false,
				modalRemoveTagsKey: tools.randomString(10),
								modalLock: false,
				modalLockKey: tools.randomString(10),
								modalDelete: false,
				modalDeleteKey: tools.randomString(10),
								modalLinkModal: false,
				modalLinkModalKey: tools.randomString(10)
				,
			}
		}
	},
	computed: {
		title() {
			return tools.camelToTitle(this.objectName) || this.routeInfo.title;
		},
		createWindowKey() {
			return this.rotatingKey + '-create';
		},
		updateWindowKey() {
			return this.rotatingKey + '-update';
		},
		archiveWindowKey() {
			return this.rotatingKey + '-update';
		},
		breadCrumbs() {
			if(this.isLoading) return [];
			return [{
				text: 'Dashboard',
				disabled: false,
				to: '/dashboard'
			}, {
				text: this.routeInfo.title,
				disabled: false,
				to: this.listPath
			}, {
				text: this.title + ' ID: ' + this.detail.id,
				disabled: true
			}]
		},
		path() {
			let currentPath = window.location.href.toString().split(window.location.host)[1];
			currentPath = currentPath.replace('/ui/', '/');
			return currentPath;
		},
		isPinned() {
			const openPins = this.$store.getters['authentication/openPins'];
			const finder = openPins.find(p => p.path === this.path);
			return !!finder;
		},
		parentSentence() {
			return '';
		},
		loadingPhrase() {
			return tools.loadingText()
		},
		showMoreMenu() {
			if (!this.moreActions.length) return false;
			if (!this.moreActions.find(ma => !ma.unpermissioned)) return false;
			return true;
		}
	},
	methods: {
		refresh() {
			this.loadingTime = 1;
			let elapser = tools.elapsed().start();
			setTimeout(() => {
				let seconds = elapser.end();
				if (seconds >= 1 && this.loadingTime >= 1) {
					this.isLoadingLong = true;
					this.loadingTime = seconds;
				}
			}, 1100);
			this.detailApi(() => {
				this.rotateKey();
				this.isLoadingLong = false;
				this.loadingTime = 0;
			});
		},
		softRefresh() {
			this.loadingTime = 1;
			let elapser = tools.elapsed().start();
			setTimeout(() => {
				let seconds = elapser.end();
				if (seconds >= 1 && this.loadingTime >= 1) {
					this.isLoadingLong = true;
					this.loadingTime = seconds;
				}
			}, 1100);
			this.reloadTimeline();
			if (this.$refs.links) this.$refs.links.refresh();
			this.showRuleButtons = false;
			apiService.detail(this.routeInfo, (err, response, meta) => {
				if (err) {
					this.isLoadingLong = false;
					this.loadingTime = 0;
					errResponse = response;
					return this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: errMsg || err.message
					});
				}
				
				tools.detailParser(this, response, meta);
				if (response.__actions) this.possibleActions = response.__actions.filter(a => a.isExecutable && !a.isInMoreMenu);
				if (response.__actions) this.moreActions = response.__actions.filter(a => a.isInMoreMenu);
				this.showRuleButtons = true;
				this.isLoadingLong = false;
				this.loadingTime = 0;
			});
		},
		runRule(action, confirmed) {
			this.currentRuleButton = action;
			if (action.buttonMustConfirm && !confirmed) {
				this.modals.ruleConfirm = true;
				return;
			}
			action.isLoading = true;
			this.currentRuleButtonLoading = true;
			apiService.runRule({ ...this.routeInfo, ...action }, (err, response) => {
				action.isLoading = false;
				this.currentRuleButtonLoading = false;
				if (err) {
					return this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err
					});
				}
				this.softRefresh();
				this.closeRuleConfirm();
			});
		},
		closeRuleConfirm() {
			this.modals.ruleConfirm = false;
			this.modals.ruleConfirmKey = tools.randomString(10);
		},
		reloadTimeline() {
			this.$refs.timeline.reload();
		},
		rotateKey() {
			this.rotatingKey = tools.randomString(10);
		},
		detailApi(done) {
			this.isLoading = true;
			let errResponse = {};
			if (this.routeInfo.id === null) {
				console.log('('+this.lastLifecyle+') Cannot fetch detail for ', this.routeInfo.namespace, this.routeInfo.name, 'because the id is null');
				return;
			}
			if (this.$refs.links) this.$refs.links.refresh();
			apiService.detail(this.routeInfo, (err, response, meta) => {
				if (err) {
					let errMsg = [];
					if (errResponse && errResponse.success === false && Array.isArray(errResponse.errors)) {
						errResponse.errors.forEach(er => {
							errMsg.push(er.message);
						});
					}
					errMsg = errMsg.join('\r\n');
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: errMsg || err.message
					});
					this.isNotFound = true;
					this.isLoading = false;
					return this.errorState = true;
				} 
				tools.detailParser(this, response, meta);
				if (response.__actions) this.possibleActions = response.__actions.filter(a => a.isExecutable && !a.isInMoreMenu);
				if (response.__actions) this.moreActions = response.__actions.filter(a => a.isInMoreMenu);
				this.showRuleButtons = true;
				this.isLoading = false;
				if (!this.isLoaded) this.isLoaded = true;
				if (!this.animateTitle) setTimeout(() => {this.animateTitle = true;}, 200);
				if (this.$route.query && this.$route.query.created) {
					this.open();
					tools.goToDetail(this.routeInfo, this.detail.id);
				}
				if (done) return done(err);
			});
		},
		goToParent() {
			tools.goToDetail(this.parent, this.parent.id);
		},
		closeActionModals() {
			this.modals.modalActionParams = false;
			this.modals.modalActionParamsKey = tools.randomString();
		},
		closeCreateWindow() {
			this.createWindow = false;
			this.getCopyJson = false;
			this.rotateKey();
		},
		closeUpdateWindow() {
			this.updateWindow = false;
			this.rotateKey();
		},
		closeDeleteWindow() {
			this.archiveWindow = false;
			this.rotateKey();
		},
		openCreateWindow() {
			this.createWindow = true;
		},
		openUpdateWindow() {
			this.updateWindow = true;
		},
		runMethod(name, actionData) {
			if(typeof this[name] === 'function') {
				this[name]();
			} else if (actionData.externalLink) {
				window.open(actionData.externalLink, actionData.linkCode);
			}
		}
		,openAvailableTags() {
			this.modals.modalAvailableTags = true;
		}
		,closeAvailableTags() {
			this.rotateKey();
			this.modals.modalAvailableTagsKey = this.rotatingKey + '-AvailableTags';
			this.modals.modalAvailableTags = false;
		}
		,openAddToQueue() {
			this.modals.modalAddToQueue = true;
		}
		,closeAddToQueue() {
			this.rotateKey();
			this.modals.modalAddToQueueKey = this.rotatingKey + '-AddToQueue';
			this.modals.modalAddToQueue = false;
		}
		,openRemoveFromQueue() {
			this.modals.modalRemoveFromQueue = true;
		}
		,closeRemoveFromQueue() {
			this.rotateKey();
			this.modals.modalRemoveFromQueueKey = this.rotatingKey + '-RemoveFromQueue';
			this.modals.modalRemoveFromQueue = false;
		}
		,openAddTags() {
			this.modals.modalAddTags = true;
		}
		,closeAddTags() {
			this.rotateKey();
			this.modals.modalAddTagsKey = this.rotatingKey + '-AddTags';
			this.modals.modalAddTags = false;
		}
		,openRemoveTags() {
			this.modals.modalRemoveTags = true;
		}
		,closeRemoveTags() {
			this.rotateKey();
			this.modals.modalRemoveTagsKey = this.rotatingKey + '-RemoveTags';
			this.modals.modalRemoveTags = false;
		}
		,openLock() {
			this.modals.modalLock = true;
		}
		,closeLock() {
			this.rotateKey();
			this.modals.modalLockKey = this.rotatingKey + '-Lock';
			this.modals.modalLock = false;
		}
		,openDelete() {
			this.modals.modalDelete = true;
		}
		,closeDelete() {
			this.rotateKey();
			this.modals.modalDeleteKey = this.rotatingKey + '-Delete';
			this.modals.modalDelete = false;
		}
		,openLinkModal() {
			this.modals.modalLinkModal = true;
		}
		,closeLinkModal() {
			this.rotateKey();
			this.modals.modalLinkModalKey = this.rotatingKey + '-LinkModal';
			this.modals.modalLinkModal = false;
		}
		,initiate_setTags() {
			this.openAvailableTags();
		}
		,initiate_addToQueue() {
			this.openAddToQueue();
		}
		,initiate_removeFromQueue() {
			this.openRemoveFromQueue();
		}
		,initiate_addTags() {
			this.openAddTags();
		}
		,initiate_removeTags() {
			this.openRemoveTags();
		}
		,initiate_aggregateQueues() {
		}
		,initiate_lock() {
			this.openLock();
		}
		,initiate_archive() {
			this.openDelete();
		}
		,initiate_link() {
			this.openLinkModal();
		}
		,initiate_getLinks() {
		}
		,initiate_removeLink() {
		}
		,initiate_checkGate() {
		}
		,initiate_removeGate() {
		}
		,initiate_getCopyJson() {
		}
		,initiate_getDeletedItems() {
		}
	},
	created() {
		this.lastLifecyle = 'created';
		tools.routeParser(this.routeInfo, this.$route);
		if (Object.keys(this.detail).length === 0) {
			this.isLoading = true;
		}
	},
	activated() {
		this.lastLifecyle = 'activated';
		let getData = false;
		tools.routeParser(this.routeInfo, this.$route);
		if (this.cached === false) {
			this.cached = Date.now();
			getData = true;
		} else {
			// time diff since cache, in seconds
			const diff = (Date.now() - this.cached) / 1000
			// if cache is too old
			if (diff > (60 * 2)) {
				this.cached = false;
				getData = true;
			}
		}
		if (getData) {
			this.animateTitle = false;
			this.detailApi();
		}
	}
}
</script>

<style scoped>
.nopad {
	padding: 0;
}
.heroTitle {
	vertical-align: middle;
	font-family: "Poppins" !important;
}
.titleOpacity {
	vertical-align: middle;
	opacity: .50;
	font-family: "Poppins" !important;
}
.display-spacing {
	margin-bottom: 20px;
}
.child-header {
	background-color: #fbfbfb;
	padding: 0 0 0 4px;
}
.child-header-divider {
	margin-bottom: 10px;
}
</style>